angular.module('unica_archive_event.archive_event_services')

.factory('ArchiveEventEditService', function ($http, getBaseApiURL) {

	var archiveEventEditService = {};

	archiveEventEditService.restore = function (eventId) {

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/event/restore/' + eventId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.event;
			}

		});

	};


	return archiveEventEditService;
});